import React from 'react';
import {connect} from 'react-redux';

import {Container} from 'reactstrap';

class UniversalHeader extends React.Component {
    state = {
        dropdownOpen: false,
        mobileOpen: false,
        applicationTooltip: false
    };

    render() {
        const {
            showFooter
        } = this.props;

        if (showFooter) {
            return (
                <div className="pr-footer mt-5">
                    <Container>
                        <p className="copyright">Copyright © PolyRents, Inc. All rights reserved.</p>
                    </Container>
                </div>
            );
        }
        else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        showFooter: state.display.navbar.showFooter
    };
}

export default connect(mapStateToProps)(UniversalHeader);


// WEBPACK FOOTER //
// ./src/containers/navigation/UniversalFooter.js